import { jsx as n } from "../../_virtual/jsx-runtime.mjs";
import { useMemo as u, useCallback as t } from "react";
import { Swiper as d, SwiperSlide as c } from "../../depend/swiper/swiper-react.mjs";
import r from "../../depend/swiper/modules/navigation.mjs";
import s from "../../depend/swiper/modules/pagination.mjs";
import g from "../../depend/swiper/modules/autoplay.mjs";
import h from "../../depend/swiper/modules/thumbs.mjs";
import b from "../../depend/swiper/modules/effect-fade.mjs";
import { reoCarousel as S } from "./css/ReoCarousel.mjs";
import w from "../../depend/classnames/index.mjs";
import "../../depend/swiper/swiper-bundle.css.mjs";
const C = (e) => {
  const l = u(() => {
    const a = {};
    return e.hasController ? e.controller ? a.navigation = e.controller : a.navigation = !0 : a.navigation = !1, e.hasPagination ? e.pagination ? a.pagination = {
      ...e.pagination,
      type: e.pagination.el ? "custom" : "bullets"
    } : a.pagination = !0 : a.pagination = !1, e.autoplay ? a.autoplay = {
      delay: e.interval ?? 1e3,
      pauseOnMouseEnter: !0,
      disableOnInteraction: !1
    } : a.autoplay = !1, e.thumbsSwiper ? a.thumbs = { swiper: e.thumbsSwiper } : a.thumbs = { swiper: null }, a;
  }, [e]), o = t((a) => {
    var i;
    (i = e.onChange) == null || i.call(e, a);
  }, [e]), f = t((a) => {
    var i;
    (i = e.onInit) == null || i.call(e, a);
  }, [e]), m = t((a) => {
    var i;
    (i = e.onSwiper) == null || i.call(e, a);
  }, [e]);
  return /* @__PURE__ */ n(
    d,
    {
      ...e,
      ...l,
      className: w(
        S,
        e.className
      ),
      modules: [r, s, g, h, b],
      direction: e.direction ?? "horizontal",
      loop: e.loop ?? !0,
      effect: e.effect ?? "slide",
      fadeEffect: e.fadeEffect ?? { crossFade: !0 },
      speed: e.speed ?? 1e3,
      spaceBetween: e.spaceBetween ?? 0,
      centeredSlides: e.centeredSlides ?? !1,
      slidesPerView: e.slidesPerView ?? 1,
      slidesPerGroup: e.slidesPerGroup ?? 1,
      simulateTouch: e.draggable ?? !1,
      grabCursor: e.draggable ?? !1,
      initialSlide: e.initialSlide ?? 0,
      focusableElements: "input, select, option, textarea, button, label",
      onSlideChange: o,
      onInit: f,
      onSwiper: m,
      children: e.items.map((a) => /* @__PURE__ */ n(
        c,
        {
          children: a.content
        },
        a.key
      ))
    }
  );
};
C.displayName = "ReoCarousel";
export {
  C as default
};
//# sourceMappingURL=ReoCarousel.mjs.map
